import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';

function Guide() {
  return (
    <div>
      <Header />
      <div style={{ padding: '64px 0' }}>
        <h3
          style={{
            color: '#000',
            fontSize: '29px',
            letterSpacing: '-1px',
            textAlign: 'center',
            fontWeight: '600',
          }}
        >
          User guide
        </h3>
        <div
          dangerouslySetInnerHTML={{
            __html: `<div class="editor"><img src="/upfiles/smarteditor/20200424092016655959402.jpg" title=""><br style="clear:both;"><br><p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">Membership Registration Guide</p><br>
            <p>① Our shopping mall is basically a membership system. Non-member purchases may be possible depending on the operating policy.<br>
            ② Membership registration is 100% free of charge, with no monthly or annual fees.<br>
            ③ When you sign up for membership, you will receive <b>$0</b> as a welcome gift. </p><p>
            ④ Accumulated bonus points can be used as cash starting from <strong>$1</strong>. <br>
            ⑤ This is a membership benefit that only applies to members who sign up online.</p><br>
            <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">Bonus Point System</p><br>
            <p>① Our shopping mall automatically credits you with a certain percentage of points depending on the product.<br>
            ② Every $1 of credit is equivalent to $1 of cash.<br>
            ③ Bonus points can be used once they reach <strong>$1</strong>, and points exceeding <strong>$10</strong> for a single order cannot be used.</p><br>
            <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">How to order products</p><br>
            <p>Ordering products from our shopping mall involves the following 7 steps.<br>
            ① Product Search<br>
            ② Direct Purchase or Add to Cart<br>
            ③ Login as a member and place an order (non-members can purchase according to our policy)<br>
            ④ Fill out the order form <br>
            ⑤ Select a payment method and pay <br>
            ⑥ Complete order (order number) <br>
            ⑦ Check your order history on My Page (Delivery confirmation)</p><br>
            <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">Order Confirmation and Delivery Tracking</p><br>
            <p>If you have placed an order on the shopping mall, you can check the order status immediately from the order history on your My Page. <br>
            Depending on the order stage, you may or may not be able to cancel or refund your order, so please use 1:1 online inquiry or customer center for guidance on this.<br>
            If non-members are allowed to purchase according to the policy, please make sure to remember your order number for confirmation.<br>
            We are currently shipping using <strong>EMS</strong> courier.</p><p>
            Once your order status changes to Shipped, you can track the exact status of your shipment using the tracking number on the carrier's website.</p><br>
            <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">Secure payment system</p><br>
            <p>
            Our shopping mall is subscribed to a secure electronic payment service (PG), and you can check the available payment methods at the order payment stage.<br />
            You can make a direct deposit via PC banking, Internet banking, telebanking or your local bank, while credit card payments are made using the KG e-payment service, so you don't have to worry about security issues, and your transaction will be recorded by KG. It will be recorded.<br><br>
    
            Available domestic credit cards<br>
            - All domestic credit cards<br><br>
    
            Accepted International Credit Cards <br>
            - VISA Card, MASTER Card, AMEX Card <br><br>
    
            Available Banks for Bank Transfer <br>
            - If you chose to make a direct deposit when you placed your order, then you can view a list of available banks.<br>
            - The account name must be the real name of the orderer as entered when placing the order.</p><br>
            <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">Delivery Period and Method</p><br>
            <p>
            For bank transfers, your ordered items will be delivered to the shipping address you provided within 2-3 days (up to 7 days at the latest) from the day of deposit. If you made a purchase with a credit card, the delivery will occur within 2-3 days from the date of purchase (up to 7 days at the latest).<br>
            Depending on the product you ordered, the delivery time may vary slightly, so please check the shipping information on the product detail page for details.<br />
            We currently use <strong>EMS</strong> courier service for delivery.</p><br>
            <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">
            Order Cancellation, Exchange, and Refund</p><br>
            <p>
            The shopping mall complies with all laws and regulations stipulated for the protection of consumers.<br />
            You can directly cancel your order if it is in an unpaid state. For cancellations after payment, please contact our customer center.<br>
            In the case of bank transfer, the order will be automatically canceled if the transfer is not made for a certain period of time, or if the buyer wishes, the order can be canceled directly on the Internet, and if the transfer is made, a refund will be issued.<br>
            If you paid by card, we will cancel the authorization if we can, but if we can't, we will transfer the full amount.<br>
            Please note that the authorization cancellation may take 2-3 days depending on the credit card company.<br>
            When returning items, please include the order number and member information for faster processing.<br>
            If there is a problem with the product or you want to exchange/refund, please contact the customer center first, and send it back to the return address with the order number, membership information (name, mobile phone number, etc.), and the reason for the return, and the payment for the product will be deposited or refunded through the customer center. (Return shipping costs are the customer's responsibility.)<br><br>
    
Return Address: Please refer to the business location (address) at the bottom copyright section.</p></div>`,
          }}
        ></div>
      </div>
      <Footer />
    </div>
  );
}
export default Guide;
